import React, { useState, useEffect, useRef } from 'react'
import { IoIosSearch, IoIosStar } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { movieService } from '../services/movie-service'

const API_IMG = 'https://image.tmdb.org/t/p/w92'
const FALLBACK = require('../assets/images/no-photo.png')

const SearchBar = () => {
  const navigate = useNavigate()
  const [query, setQuery] = useState('')
  const [results, setResults] = useState([])
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const wrapRef = useRef(null)

  // Debounced suggestions
  useEffect(() => {
    const q = query.trim()
    if (!q) {
      setResults([])
      setLoading(false)
      return
    }
    setLoading(true)
    const t = setTimeout(async () => {
      const data = await movieService.searchAll(q)
      const clean = data
        .filter((r) => r.media_type !== 'person' && (r.title || r.name))
        .slice(0, 6)
      setResults(clean)
      setLoading(false)
    }, 350)
    return () => clearTimeout(t)
  }, [query])

  // Close on outside click
  useEffect(() => {
    const onClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', onClick)
    return () => document.removeEventListener('mousedown', onClick)
  }, [])

  const goToDetails = (media) => {
    setOpen(false)
    setQuery('')
    navigate(`/show/${media.id}`, { state: { media, fromSearch: true } })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const q = query.trim()
    if (!q) return
    setOpen(false)
    const all = await movieService.searchAll(q)
    navigate('/searched-movies', {
      state: { searchResults: all, searchQuery: q },
    })
  }

  return (
    <div className='search-bar-container' ref={wrapRef}>
      <form className='flex' onSubmit={handleSubmit}>
        <input
          type='text'
          value={query}
          placeholder='Search movies & TV…'
          onChange={(e) => {
            setQuery(e.target.value)
            setOpen(true)
          }}
          onFocus={() => setOpen(true)}
        />
        <button className='button' aria-label='Search'>
          <IoIosSearch className='svg' />
        </button>
      </form>

      {open && query.trim() && (
        <div className='search-suggest'>
          {loading && <div className='suggest-state'>Searching…</div>}

          {!loading && results.length === 0 && (
            <div className='suggest-state'>No matches found</div>
          )}

          {!loading &&
            results.map((r) => {
              const title = r.title || r.name
              const year = (r.release_date || r.first_air_date || '').substring(0, 4)
              return (
                <button
                  className='suggest-item'
                  key={r.id}
                  onClick={() => goToDetails(r)}
                >
                  <img
                    src={r.poster_path ? API_IMG + r.poster_path : FALLBACK}
                    alt={title}
                  />
                  <div className='suggest-info'>
                    <span className='suggest-title'>{title}</span>
                    <span className='suggest-meta'>
                      {r.media_type === 'tv' ? 'TV' : 'Movie'}
                      {year && ` · ${year}`}
                    </span>
                  </div>
                  {r.vote_average > 0 && (
                    <span className='suggest-rate'>
                      <IoIosStar /> {r.vote_average.toFixed(1)}
                    </span>
                  )}
                </button>
              )
            })}

          {!loading && results.length > 0 && (
            <button className='suggest-all' onClick={handleSubmit}>
              See all results for “{query.trim()}”
            </button>
          )}
        </div>
      )}
    </div>
  )
}

export default SearchBar
